// tslint:disable:max-classes-per-file

import { Action } from '@ngrx/store';
import { RpcError } from '../../../shared/error/rpc.error';

import { CompanySettings } from '../../model/company-settings';
import { VoidReason } from 'app/settings/model/void-reason';

export const LOAD_COMPANY_SETTINGS = '[Company Settings] Load Company Settings';
export const LOAD_COMPANY_SETTINGS_SUCCESS =
  '[Company Settings] Load Company Settings Success';
export const LOAD_COMPANY_SETTINGS_FAIL =
  '[Company Settings] Load Company Settings FAIL';

export const SAVE_COMPANY_SETTINGS = '[Company Settings] Save Company Settings';
export const SAVE_COMPANY_SETTINGS_SUCCESS =
  '[Company Settings] Save Company Settings Success';
export const SAVE_COMPANY_SETTINGS_FAIL =
  '[Company Settings] Save Company Settings FAIL';

export const REMOVE_COMPANY_SETTING_ERROR =
  '[Company Settings] Remove Company Settings Error Message';

export class LoadCompanySettings implements Action {
  public readonly type: string = LOAD_COMPANY_SETTINGS;

  constructor(public payload: any = null) {}
}

export class LoadCompanySettingsSuccess implements Action {
  public readonly type: string = LOAD_COMPANY_SETTINGS_SUCCESS;

  constructor(public payload: CompanySettings) {}
}

export class LoadCompanySettingsFail implements Action {
  public readonly type: string = LOAD_COMPANY_SETTINGS_FAIL;

  constructor(public payload: any) {}
}

export class SaveCompanySettings implements Action {
  public readonly type: string = SAVE_COMPANY_SETTINGS;

  constructor(
    public payload: { settings: CompanySettings; voidReasons?: VoidReason[] }
  ) {}
}

export class SaveCompanySettingsSuccess implements Action {
  public readonly type: string = SAVE_COMPANY_SETTINGS_SUCCESS;

  constructor(public payload: CompanySettings) {}
}

export class SaveCompanySettingsFail implements Action {
  public readonly type: string = SAVE_COMPANY_SETTINGS_FAIL;

  constructor(
    public payload: { error: string | RpcError; settings: CompanySettings }
  ) {}
}

export class RemoveCompanySettingsError implements Action {
  public readonly type: string = REMOVE_COMPANY_SETTING_ERROR;

  constructor(public payload: any = null) {}
}

export type CompanySettingsActions =
  | LoadCompanySettings
  | LoadCompanySettingsSuccess
  | LoadCompanySettingsFail
  | SaveCompanySettings
  | SaveCompanySettingsSuccess
  | SaveCompanySettingsFail
  | RemoveCompanySettingsError;
